import React, { useState, useEffect } from "react";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import { Link } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { FiInfo } from "react-icons/fi";
import { NODE_HOST_URL } from "../api/Api";
import { handleUserLog } from "../../Utils/Utils";
const RcsOnboarding = () => {
    const [rcsOnboardingList, setRcsOnboardingList] = useState([]);
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    useEffect(() => {

        const fetchList = async () => {
            const payload = {
                user_id: userId,
                token: userToken,
                method: "onboarding_retrieve",
            };

            try {
                const response = await axios.post(`${NODE_HOST_URL}/rcs`, payload);
                if (response.data.success) {
                    const sortedData = response.data.data.sort((a, b) => {
                        return new Date(b.created_date) - new Date(a.created_date); // Replace 'date' with actual date field name
                    });
                    setRcsOnboardingList(sortedData);
                }
            } catch (error) {
                console.log(error);
            }
        };


        fetchList();


    }, [userId])
    const allowedDomains = ["console.authkey.io", "localhost:3000"];
    const currentDomain = window.location.host;
    const showHelpButton = allowedDomains.includes(currentDomain);
    return (
        <DashboardLayout>
            <main className="content">
                <div className="container-fluid p-0">
                    <div className="d-flex justify-content-between align-items-center w-100 mb-3 flex-wrap">
                        <div>
                            <h3 className="mb-0">
                                <strong>RCS </strong> Onboarding List
                            </h3>
                        </div>

                        <div className="col-auto ml-auto text-right mt-n1 d-flex align-items-center" style={{ gap: '10px' }}>
                            <Link
                                className="btn btn-primary btn-sm"
                                to="/dashboard/apply-rcs"
                                onClick={() => handleUserLog("", " clicked_apply_onboarding_button", "rcs", "User click on Apply Onboarding button", "rcs_onboarding_list", "", "")}
                            >
                                Apply Onboarding
                            </Link>
                            {showHelpButton && (

                                <a
                                    href="https://docs.google.com/document/d/1icFy50dD5GW01biTZrlCgVDugvfOPes5JkZjPXWCXbE/edit?usp=sharing"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button onClick={() => handleUserLog("", "clicked_helped_button_rcs", "rcs", "User click on Help button", "rcs_onboarding_list", "", "")} className="btn btn-primary btn-sm">
                                        <FiInfo style={{ fontSize: "18px", marginRight: "2px" }} />
                                        Help
                                    </button>
                                </a>

                            )}
                        </div>
                    </div>





                    <div className="d-flex justify-content-center align-items-center w-100">
                        <div className="card w-100">
                            <div className="card-header">
                                {/* <h5 className="card-title mb-0">Rcs Template List </h5> */}
                            </div>
                            <hr className="m-0" />
                            <div className="">
                                {rcsOnboardingList ? (
                                    <div className="table-responsive">
                                        <table className="table table-hover  project  my-0">
                                            <thead>
                                                <tr>
                                                    <th>Display Name</th>
                                                    <th>Primary email</th>
                                                    <th>Primary Phone</th>
                                                    <th>Primary website</th>
                                                    <th>Created Date</th>
                                                    <th>Region</th>
                                                    <th>Color</th>
                                                    <th>Manager Name</th>
                                                    <th>Manager Phone</th>
                                                    <th>Manager Email</th>
                                                    <th>Privacy Policy</th>
                                                    <th>Terms of Service</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rcsOnboardingList.map((item) => (
                                                    <tr key={item._id}>
                                                        <td>{item.display_name}</td>
                                                        <td>{item.primary_email}</td>
                                                        <td>{item.primary_phone}</td>
                                                        <td>{item.primary_website}</td>
                                                        <td>{item.created_date}</td>
                                                        <td>{item.region}</td>
                                                        <td>{item.color}</td>
                                                        <td>{item.manager_name}</td>
                                                        <td>{item.manager_phone}</td>
                                                        <td>{item.manager_company_email}</td>
                                                        <td>{item.privacy_policy}</td>
                                                        <td>{item.terms_service}</td>
                                                        <td>
                                                            {item.status === 0 ? (
                                                                <span className="badge badge-primary">
                                                                    {" "}
                                                                    Pending{" "}
                                                                </span>
                                                            ) : item.status === 1 ? (
                                                                <span className="badge bg-success">
                                                                    {" "}
                                                                    Approved{" "}
                                                                </span>
                                                            ) : item.status === 2 ? (
                                                                <span className="badge badge-secondary">
                                                                    {" "}
                                                                    Processing{" "}
                                                                </span>
                                                            ) : item.status === 3 ? (
                                                                <span className="badge badge-info">
                                                                    {" "}
                                                                    Rejected{" "}
                                                                </span>
                                                            ) : null}
                                                        </td>
                                                        {item.status === 0 && <td>
                                                            {" "}
                                                            <a
                                                                href={`/dashboard/edit-rcs/${item._id}`}
                                                                onClick={() => handleUserLog("", "update_rcs_onboarding", "rcs", "User click on edit onboarding button", "rcs_onboarding_list", "", { id: item._id })}
                                                            >
                                                                <span className="badge bg-info">
                                                                    {" "}
                                                                    Edit{" "}
                                                                </span>{" "}
                                                            </a>{" "}
                                                        </td>}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <div className="card-body">
                                            <p>No Recod Found....</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </main>
        </DashboardLayout>

    )
}

export default RcsOnboarding